import {
  EngagementFeedWithUser,
  NewsfeedPromotesDto,
} from '@epicuro-next/data/engagement/engagement-models';
import { List } from '@epicuro-next/models/engagement';
import { createAction, props } from '@ngrx/store';

/** Edit action */
export const editArticle = createAction(
  '[News Feed] Edit Article',
  props<{
    article: EngagementFeedWithUser;
    previousPromotionStartDate: string;
  }>(),
);

/** Edit success action */
export const editArticleSuccess = createAction(
  '[News Feed] Edit Article Success',
  props<{ article: EngagementFeedWithUser }>(),
);

/** Edit fail action */
export const editArticleFail = createAction('[News Feed] Edit Article Fail');

export const editArticlePromoteReferencesSuccess = createAction(
  '[News Feed] Edit Article Promote References Success',
  props<{ id: string; promoteReferences: NewsfeedPromotesDto }>(),
);

export const editArticlePromoteReferencesFail = createAction(
  '[News Feed] Edit Article Promote References Fail',
);

export const partialUpdate = createAction(
  '[News Feed] Partial Update',
  props<{ article: Partial<EngagementFeedWithUser> }>(),
);

export const editArticleRemoveFromTodaySpotlight = createAction(
  '[News Feed] Edit Article Remove From Spotlight',
  props<{ feedId: string }>(),
);

export const editArticleWithPromotionDateUpdateSuccess = createAction(
  '[News Feed] Edit Article with Promotion Date Update Success',
);

export const editListArticle = createAction(
  '[News Feed] Edit List Article',
  props<{ list: List }>(),
);
